var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('bread-crumb',{attrs:{"navigationArray":_vm.navigationLink}}),_c('sctucture-chamber')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }